const filterMilestonesByLWPlanningSummary=(milestone, initiative, currentFilter)=>{
        const milestoneStartDate = milestone.startDate
          ? new Date(milestone.startDate)
          : null;
        const milestoneEndDate = milestone.endDate
          ? new Date(milestone.endDate)
          : null;
        const currentDatePlus7Days = new Date();
        currentDatePlus7Days.setDate(currentDatePlus7Days.getDate() + 7);
        const milestoneStatus = milestone.status;
        // Initiative-level status check
        const initiativeStatus = initiative.weeklyStatus;
      
        if (['On Hold', 'Cancelled', 'Rejected'].includes(initiativeStatus)) {
          if (
            initiativeStatus === 'On Hold' &&
            currentFilter.includes('Initiative on hold')
          ) {
            return true; // Return true if initiative is on hold and filter is selected
          } else if (
            (initiativeStatus === 'Cancelled' || initiativeStatus === 'Rejected') &&
            currentFilter.includes('Initiative cancelled')
          ) {
            return true; // Return true if initiative is cancelled/rejected and filter is selected
          }
          return false; // If initiative is on hold/cancelled/rejected, only return true if the corresponding initiative-level filter is selected
        }
      
        // If the initiative is NOT On Hold, Cancelled, or Rejected, then apply the milestone-level logic:
      
        // No start or end date → treat as "<not set>"
        if (!milestoneStartDate || !milestoneEndDate) {
          return currentFilter.includes('<not set>');
        }
      
        const msInWeek = 7 * 24 * 60 * 60 * 1000;
        const timeDiff = currentDatePlus7Days.getTime() - milestoneEndDate.getTime();
        const weeksLate = timeDiff / msInWeek;
      
        if (milestoneStatus !== 'Completed' && currentDatePlus7Days > milestoneEndDate) {
          // Milestone is late (considering due date as currentDate + 7 days)
          if (weeksLate > 4 && currentFilter.includes('Late (more than 4 weeks)')) {
            return true;
          } else if (
            weeksLate >= 1 &&
            currentFilter.includes('Late (1 to 4 weeks)')
          ) {
            return true;
          } else if (
            weeksLate < 1 &&
            currentFilter.includes('Late (less than 1 week)')
          ) {
            return true;
          }
        } else if (
          milestoneStatus === 'Not started' &&
          currentDatePlus7Days > milestoneStartDate &&
          currentFilter.includes('Late to start')
        ) {
          // Late to start (considering start date compared to currentDate + 7 days)
          return true;
        } else if (
          milestoneStatus === 'Not planned' &&
          currentFilter.includes('Not planned')
        ) {
          return true;
        } else if (
          milestoneStatus === 'Not started' &&
          currentFilter.includes('Not started')
        ) {
          return true;
        } else if (
          milestoneStatus === 'Started' &&
          currentDatePlus7Days >= milestoneStartDate &&
          currentDatePlus7Days <= milestoneEndDate
        ) {
          const daysUntilDueLW =
            (milestoneEndDate.getTime() - currentDatePlus7Days.getTime()) /
            (1000 * 60 * 60 * 24);
      
          if (daysUntilDueLW <= 7 && currentFilter.includes('Due soon')) {
            // Milestone is approaching its end within a week (from currentDate + 7 days)
            return true;
          } else if (daysUntilDueLW > 7 && currentFilter.includes('On plan')) {
            return true;
          } else if (daysUntilDueLW <= 0 && currentFilter.includes('On plan')) {
            return true; // Consider milestones ending by currentDate + 7 days as 'On plan'
          }
        } else if (
          milestoneStatus === 'Not Started' &&
          currentDatePlus7Days <= milestoneEndDate
        ) {
          const daysUntilDueLW =
            (milestoneEndDate.getTime() - currentDatePlus7Days.getTime()) /
            (1000 * 60 * 60 * 24);
      
          if (daysUntilDueLW <= 7 && currentFilter.includes('Due soon')) {
            // Milestone hasn't started yet but is due within a week (from currentDate + 7 days)
            return true;
          } else if (daysUntilDueLW > 7 && currentFilter.includes('On plan')) {
            return true;
          } else if (daysUntilDueLW <= 0 && currentFilter.includes('On plan')) {
            return true; // Consider milestones due by currentDate + 7 days as 'On plan'
          }
        } else if (
          milestoneStatus === 'Completed' &&
          currentFilter.includes('Completed')
        ) {
          return true;
        } else if (
          milestoneStatus === 'Cancelled' &&
          currentFilter.includes('Cancelled')
        ) {
          return true;
        }
      
        return false; // This milestone doesn't match the (LW) Planning summary filter
      
}
export default filterMilestonesByLWPlanningSummary;